import * as validate from "../../../Components/Modals/validations";
import { params, const_var } from "../reducer";
import * as cuBuilding from "../building_pricing/pricingReducer";
import * as cuComponent from "../building_component/componentReducer";
export const orderState = {
	checkorderValidateonly: "",
	checkoutModal: false,
	termsAndConditionDialogExtraClassToggle: false,
	privacyPolicyCheckbox: false,
	backToCheckoutBtn: true,
	showProcessLoader: false,
	isShowThankYou: false,
	Updatedconst_var: "",
	agreeTermsAndConditionCheckbox: false,
	billingAddressCheckbox: false,
	addNewBillingAddress: false,
	displayerrorMessage: "",
	order_data: "",
	paymentOption: "",
	sign_jpeg: "",
	sigPad: {},
	blobImg: "",
	bjD: [],
	orderPDFURL: "",
	informUser: "",
	informUserFlag: false,
	invoicePDFURL: "",
	i_g_A_y: [],
	alertUsedMSG: "",
	shippingState: "Select",
	billingState: "Select",
	TempData: { first_name: "", last_name: "", email: "", phone_no: "", shipping_zipcode: "", shipping_address_line_1: "", shippingState: "" },
	checkflagformaindomainurl: const_var.crmSetting.main_domain_url
};
orderState.displayerrorMessage = const_var.displayerrorMessage;
orderState.paymentOption = const_var.paymentOption;
orderState.bjD = const_var.bjD;
orderState.isKLinkEnable = const_var.isKLinkEnable;
if (
	const_var.isKLinkEnable == true &&
	const_var.crmSetting.pre_quote_form == true &&
	const_var.KLinkDataUpdate == false &&
	const_var.post_data &&
	const_var.post_data.first_name != undefined &&
	const_var.post_data.full_name != ""
) {
	const_var.post_data.full_name = "";
	const_var.post_data.first_name = "";
	const_var.post_data.last_name = "";
	const_var.post_data.shipping_address_line_1 = "";
	const_var.post_data.shipping_zipcode = "";
	const_var.post_data.shipping_state = "";
	const_var.shippingState = "Select";
	const_var.KLinkDataUpdate = true;
}
const orderReducer = (state = orderState, action) => {
	const newState = { ...state };

	switch (action.type) {
		case "handleOrderModal":
			if (action.payload == "open") {
				if (
					const_var.crmSetting.applyPriceCheck != undefined &&
					const_var.crmSetting.applyPriceCheck == true &&
					const_var.BuildingPriceArrar["order_total"] != undefined &&
					parseFloat(const_var.BuildingPriceArrar["order_total"].toFixed(2)) < parseFloat(3000)
				) {
					state.isShowThankYou = true;
					state.alertUsedMSG = "Sorry, we are not accepting orders below $3000 (plus tax) currently. Please contact us for your requirements at - " + const_var.crmSetting.phone_number;
				} else {
					const_var.focusedSection = "";

					if (params.isShowCenter || params.is_translusant) {
						params.isShowCenter = false;
						params.is_translusant = false;
						cuBuilding.BuildingUpdate(true);
						if (params.add_front_lean) cuBuilding.UpdateFrontLean();
						if (params.add_left_lean) cuBuilding.UpdateLeftLean();
						if (params.add_right_lean) cuBuilding.UpdateRightLean();
						if (params.add_back_lean) cuBuilding.UpdateBackLean();
					}
					const_var.controls.target.set(0, params.p_h / 2, 0);
					const_var.camera.position.set(0, params.p_h + 0, 3.25 * params.p_d);
					const_var.controls.update();

					state.displayerrorMessage = const_var.displayerrorMessage;
					state.isShowThankYou = false;
					state.alertUsedMSG = "";
					const_var.checkIval = 0;
					const_var.checkCaptuareImage = false;
					const_var.i_g_A_y = [];
					const_var.selectedTabKeyForWheel = "capture";

					const_var.activeTab = "buildingtypetab";
					cuComponent.TsCeSot("quote");
					if (const_var.crmSetting.pre_quote_form == true && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false && const_var.loginSession == false) {
						state.TempData.first_name = const_var.post_data.first_name;
						state.TempData.last_name = const_var.post_data.last_name;
						state.TempData.email = const_var.post_data.email;
						state.TempData.phone_no = const_var.post_data.phone_no;
						state.TempData.shipping_zipcode = const_var.post_data.address != undefined && const_var.post_data.address.length > 0 ? const_var.post_data.address[0].zipcode : "";
						state.TempData.shipping_address_line_1 = const_var.post_data.address != undefined && const_var.post_data.address.length > 0 ? const_var.post_data.address[0].address_line_1 : "";
						state.TempData.shippingState = const_var.stateNameAcordingAPI[params.p_s_n];
						state.shippingState = state.TempData.shippingState;
						const_var.shippingState = state.TempData.shippingState;
						state.isKLinkEnable = const_var.isKLinkEnable;
						const_var.post_data["shipping_zipcode"] = const_var.post_data.address != undefined && const_var.post_data.address.length > 0 ? const_var.post_data.address[0].zipcode : "";
						const_var.post_data["shipping_address_line_1"] = const_var.post_data.address != undefined && const_var.post_data.address.length > 0 ? const_var.post_data.address[0].address_line_1 : "";
						const_var.tempPostData = JSON.parse(JSON.stringify(state.TempData));
						state.KLinkDataUpdate = const_var.KLinkDataUpdate;
					}
					const_var.showProcessLoaderchk = true;
					state.checkoutModal = true;

					state.order_data = {
						building_name: const_var.post_data["building"].display_building_type_name,
						phone_number: const_var.crmSetting.phone_number,
						order_now: const_var.crmSetting.order_now,
						width: const_var.post_data["building"].width,
						length: const_var.post_data["building"].length,
						height: const_var.post_data["building"].height,
						roofstyle: const_var.post_data["building"].roof_style_name,
						order_total: const_var.post_data["building"].order_total,
						down_payment_discount_total: const_var.post_data["building"].down_payment_discount_total,
						discount_amount: const_var.post_data["building"].discount_amount,
						sub_order_total: const_var.BuildingPriceArrar["sub_order_total"],
						new_down_payment_total:
							const_var.BuildingPriceArrar["new_down_payment_total"] != undefined ? (const_var.BuildingPriceArrar["new_down_payment_total"] + const_var.BuildingPriceArrar["grvy_value"]).toFixed(2) : 0,
						downPersentage: const_var.post_data["building"].down_payment_rate,
						is_loggedin: const_var.loginSession
					};
					state.blobImg = const_var.renderer.domElement.toDataURL("image/jpeg");
				}
			} else {
				if (const_var.i_g_A_y.length == 0) {
					const_var.checkCaptuareImage = false;
				}
				state.isShowThankYou = false;
				state.alertUsedMSG = "";
				state.checkoutModal = false;
				const_var.selectedTabKeyForWheel = "";
				const_var.displayerrorMessage = {};
			}
			return {
				...state,
				checkorderValidateonly: action
			};
			break;
		case "onorderTextFiledChangeValue":
			state.isShowThankYou = false;
			state.alertUsedMSG = "";
			validate.onTextFiledChangeValue(action.event, action.value, action.keyword);
			if (
				action.value == "first_name" ||
				action.value == "last_name" ||
				action.value == "email" ||
				action.value == "sensei_sales_id" ||
				action.value == "phone_no" ||
				action.value == "shipping_zipcode" ||
				action.value == "shipping_address_line_1"
			) {
				const_var.post_data[action.value] = action.event.target.value;
				state.TempData[action.value] = action.event.target.value;
			}
			return {
				...state,
				checkorderValidateonly: action
			};
			break;
		case "onOrderSubmitCheckout":
			validate.onSubmitForm(action.event);
			if (state.agreeTermsAndConditionCheckbox == false) {
				const_var.displayerrorMessage.agreeTermsAndConditionCheckbox = "Terms and conditions is required ";
				const_var.checkValidate = true;
			}
			state.informUserFlag = false;
			state.informUser = "";
			action.event.preventDefault();
			if (const_var.checkValidate == false) {
				state.showProcessLoader = true;
			}
			return {
				...state,
				checkorderValidateonly: action.event
			};
			break;
		case "onSubmitCheckoutApi":
			state.showProcessLoader = true;
			const_var.alertUsedFor = "onSubmitCheckoutApi";
			const_var.showProcessLoaderchk = false;
			const_var.thankYouForSaveLater = false;
			const_var.showProcessLoader = false;
			if (const_var.crmSetting.gTag == true) {
				window.analysisCode();
			}
			if (action.event.status == true) {
				state.invoicePDFURL = action.event.invoice_pdf;
				state.orderPDFURL = action.event.order_pdf;
				if (action.event.invoice_status == "unpaid") {
					state.informUser = action.event.message;
					state.informUserFlag = true;
				}
				const_var.checkoutModal = false;
				state.isShowThankYou = true;
				const_var.shippingState = "Select";

				state.checkoutModal = false;
				state.billingAddressCheckbox = false;
				state.agreeTermsAndConditionCheckbox = false;
				state.privacyPolicyCheckbox = false;
				state.showProcessLoader = false;
				if (action.event.status == false) {
					const_var.paymentFailedMessage = true;
				}
				const_var.shippingState = "Select";
				state.TempData = { first_name: "", last_name: "", email: "", phone_no: "", shipping_zipcode: "", shipping_address_line_1: "", shippingState: "" };
			} else {
				const_var.shippingState = "Select";
				state.TempData = { first_name: "", last_name: "", email: "", phone_no: "", shipping_zipcode: "", shipping_address_line_1: "", shippingState: "" };
				state.showProcessLoader = false;
				let responseMessage = action.event.message;
				responseMessage = responseMessage.replace("[PhoneNumber]", const_var.crmSetting.phone_number);
				responseMessage = responseMessage.replace("[Email]", const_var.crmSetting.email);
				const_var.checkoutModal = false;
				const_var.shippingState = "Select";

				state.isShowThankYou = true;
				state.alertUsedMSG = responseMessage;
			}
			return {
				...state,
				checkorderValidateonly: action.event
			};
			break;
		case "onSubmitCheckoutApiErrorhandling":
			var newmsgforreload = "";
			state.showProcessLoader = false;
			state.orderPDFURL = "";
			state.isShowThankYou = true;
			state.alertUsedMSG = action.value;
			newmsgforreload = action.value;
			return {
				...state,
				checkorderValidateonly: action
			};
			break;

		case "privacyPolicyCheckboxChange":
			state.privacyPolicyCheckbox = !state.privacyPolicyCheckbox;
			if (state.privacyPolicyCheckbox == true && typeof const_var.sigPad.isEmpty === "function" && const_var.sigPad.isEmpty() != undefined && const_var.sigPad.isEmpty() == false && const_var.sign_jpeg != "") {
				state.backToCheckoutBtn = false;
			} else {
				state.backToCheckoutBtn = true;
			}
			return {
				...state,
				checkorderValidateonly: state.privacyPolicyCheckbox
			};
			break;
		case "agreeTermsAndConditionCheckboxChange":
			state.agreeTermsAndConditionCheckbox = true;
			state.termsAndConditionDialogExtraClassToggle = true;
			state.displayerrorMessage.agreeTermsAndConditionCheckbox = "";
			const_var.checkValidate = false;
			return {
				...state,
				checkorderValidateonly: state.displayerrorMessage.agreeTermsAndConditionCheckbox
			};
			break;
		case "termsAndConditionProceedBtn":
			state.termsAndConditionDialogExtraClassToggle = false;
			return {
				...state,
				checkorderValidateonly: state.termsAndConditionDialogExtraClassToggle
			};
			break;
		case "billingAddressCheckboxChange":
			if (action.val == "addBilling") {
				state.addNewBillingAddress = !state.addNewBillingAddress;
				const_var.billingAddressCheckbox = false;
				state.billingAddressCheckbox = false;
			} else {
				state.billingAddressCheckbox = !state.billingAddressCheckbox;
				const_var.billingAddressCheckbox = state.billingAddressCheckbox;
				state.addNewBillingAddress = false;
			}
			return {
				...state,
				checkorderValidateonly: state.billingAddressCheckbox
			};
			break;
		case "genrateSignature":
			if (action.event == "Reset") {
				const_var.sigPad.clear();
				const_var.sign_jpeg = "";
				state.sign_jpeg = "";
				state.backToCheckoutBtn = true;
			} else {
				if (const_var.sigPad.isEmpty() == true) {
					state.backToCheckoutBtn = true;
				} else if (state.privacyPolicyCheckbox == true && const_var.sigPad.isEmpty() == false) {
					state.backToCheckoutBtn = false;
				}
				state.sign_jpeg = action.value;
				const_var.sign_jpeg = action.value;
			}
			return {
				...state,
				checkorderValidateonly: action.value + state.backToCheckoutBtn
			};
			break;
		case "SHIPPINGSTATECHANGE":
			const_var.shippingState = action.value;
			state.shippingState = action.value;
			return {
				...state,
				checkorderValidateonly: action
			};
			break;
		case "BILLINGSTATECHANGE":
			const_var.billingState = action.value;
			state.billingState = action.value;
			return {
				...state,
				checkorderValidateonly: action
			};
			break;
		case "updateTempPostData":
			if (action.isPostReset == true) {
				const_var.post_data["first_name"] = const_var.tempPostData.first_name;
				const_var.post_data["last_name"] = const_var.tempPostData.last_name;
				const_var.post_data["email"] = const_var.tempPostData.email;
				const_var.post_data["phone_no"] = const_var.tempPostData.phone_no;
				const_var.post_data["shipping_zipcode"] = const_var.tempPostData.shipping_zipcode;
				const_var.post_data["shipping_address_line_1"] = const_var.tempPostData.shipping_address_line_1;

				state.TempData["first_name"] = const_var.tempPostData.first_name;
				state.TempData["last_name"] = const_var.tempPostData.last_name;
				state.TempData["email"] = const_var.tempPostData.email;
				state.TempData["phone_no"] = const_var.tempPostData.phone_no;
				state.TempData["shipping_zipcode"] = const_var.tempPostData.shipping_zipcode;
				state.TempData["shipping_address_line_1"] = const_var.tempPostData.shipping_address_line_1;
				state.TempData["shippingState"] = const_var.tempPostData.shippingState;

				const_var.shippingState = const_var.tempPostData.shippingState;
				state.shippingState = const_var.tempPostData.shippingState;
			}
			const_var.tempPostData = action.value;
			const_var.proceedToMobileSave = false;
			return {
				...state,
				action
			};
			break;
	}
	return newState;
};
export default orderReducer;
